module.exports = "<div class=\"color-well\" :style=\"style\"></div>\n"